import React, { useState } from "react";
import "./Suggestion.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import locationIcon from "@assets/icons/location.png";

interface ISuggestion {
  searchResult: any;
  onSelect: (item: any) => void;
}

const Suggestion: React.FC<ISuggestion> = ({ searchResult, onSelect }) => {
  return (
    <div className="Suggestion">
      <div className="suggestion-wrap">
        {searchResult.length == 0 ? (
          <Spin indicator={<LoadingOutlined spin />} size="small" />
        ) : (
          searchResult.map((item: any, index: number) => {
            return (
              <div
                className="suggestion-item"
                key={index}
                onClick={() => onSelect(item)}
              >
                <img src={locationIcon} width={16} />
                <span className="location">{item.display_name}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Suggestion;
